<template>
	<div class="card-produto">
		<div class="card-produto-header">
			<img
				class="card-produto-img"
				:src="produto.imagem"
				v-if="produto.imagem != null"
				:alt="produto.nome"
			/>
			<img
				class="card-produto-img"
				src="https://via.placeholder.com/250x200"
				v-if="produto.imagem == null"
				alt="Placeholder"
			/>

			<div class="box-desconto" :style="produto.style" v-if="produto.comprejunto">
				<div class="text-center">
					<b>
						<span>{{produto.text}}</span>
					</b>
				</div>
			</div>
		</div>
		<div class="card-produto-title" style="text-align: center;padding-top:5px; ">
			<span class="produto--nome">{{produto.nome}}</span>
		</div>
		<div class="card-produto-body">
			<template v-if="personalizacao.opcao_tipo_card == 'completo'">
				<div
					class="produto--detalhes sg-cor-secundaria"
					style="vertical-align: top; margin-top: 0px; min-height: 100px"
					v-if="!produto.comprejunto"
				>
					<p>
						<b>Ref.:</b>
						{{produto.referencia}}
					</p>
					<p>
						<b>Quantidade:</b>
						<span class="quantidade-card-produto">{{produto.quantidade}}</span>
					</p>
					<p v-if="produto.cor">
						<b>Cor:</b>
						<span class="cor-card-produto">{{produto.cor}}</span>
					</p>
					<p
						v-if="produto.tamanho_sangria != null && produto.tamanho_sangria != '' && produto.tamanho_sangria != 'x'"
					>
						<b>Tam. Arte:</b>
						{{produto.tamanho_sangria}}
					</p>
					<p v-if="produto.cobertura != null && produto.cobertura != ''">
						<b>Cobertura:</b>
						{{produto.cobertura}}
					</p>
					<p v-if="produto.papel != null && produto.papel != ''">
						<b>Material:</b>
						{{produto.papel}}
					</p>
					<p
						v-if="produto.prazo_producao > 0 && produto.prazo_producao > 1 && produto.prazo_producao_periodo == 'd'"
					>
						<b>Produção:</b>
						{{produto.prazo_producao}} dias
					</p>
					<p
						v-if="produto.prazo_producao > 0 && produto.prazo_producao <= 1 && produto.prazo_producao_periodo == 'd'"
					>
						<b>Produção:</b>
						{{produto.prazo_producao}} dia
					</p>
					<p
						v-if="produto.prazo_producao > 0 && produto.prazo_producao > 1 && produto.prazo_producao_periodo == 'h'"
					>
						<b>Produção:</b>
						{{produto.prazo_producao}} horas
					</p>
					<p
						v-if="produto.prazo_producao > 0 && produto.prazo_producao <= 1 && produto.prazo_producao_periodo == 'h'"
					>
						<b>Produção:</b>
						{{produto.prazo_producao}} hora
					</p>
				</div>
				<div
					class="produto--detalhes sg-cor-secundaria"
					style="vertical-align: top; margin-top: 0px; min-height: 100px"
					v-if="produto.comprejunto"
				>
					<p style="justify-content: center; display: flex;">
						<b>Produtos</b>
					</p>
					<p v-for="p in produto.produtos" style="justify-content: center; display: flex;">{{p.nome}}</p>
				</div>
			</template>
			<!--<template v-else-if="personalizacao.opcao_tipo_card == 'simples'">-->
			<!--<div class="produto&#45;&#45;detalhes sg-cor-secundaria" style="vertical-align: top; margin-top: 0px; min-height: 100px" v-if="!produto.comprejunto">-->
			<!--</div>-->
			<!--<div class="produto&#45;&#45;detalhes sg-cor-secundaria" style="vertical-align: top; margin-top: 0px; min-height: 100px" v-if="produto.comprejunto">-->
			<!--</div>-->
			<!--</template>-->
			<div style="text-align: center" v-if="produto.preco_logado">
				<p class="produto--preco-por">
					<b>Logue-se para ver o preço</b>
				</p>
			</div>
			<div style="text-align: center" v-else-if="produto.sob_consulta == 1">
				<p class="produto--preco-por">
					<b>Sob consulta</b>
				</p>
			</div>
			<div style="text-align: center" v-else>
				<span
					class="produto--preco-de"
					v-if="produto.preco_promocional && !produto.verificaRevendedor"
				>de: {{produto.preco_venda | currency(2)}}</span>
				<span
					class="produto--preco-de"
					v-if="produto.preco_promocional && !produto.verificaRevendedor"
					style="font-size: 12px"
				>&nbsp;por:</span>
				<p class="produto--preco-por" v-if="produto.preco_promocional">
					<b class="produto--preco-por">{{produto.precoAttribute | currency(2)}}</b>
				</p>
				<span
					class="produto--preco-de"
					v-if="!produto.preco_promocional"
					style="text-decoration: unset"
				>a partir de:</span>
				<p class="produto--preco-por" v-if="!produto.preco_promocional">
					<b class="produto--preco-por">{{produto.precoAttribute | currency(2)}}</b>
				</p>
			</div>
		</div>

		<!--Botão do card fixo na tela-->

		<template v-if="personalizacao.tipo_botao_card == 'fixo'">
			<div v-if="produto.preco_logado">
				<a href="#login" data-toggle="modal" data-target="#modalLogin" class="btn sg-botao">
					<i class="fas fa-sign-in-alt"></i> Logar
				</a>
			</div>
			<div v-else>
				<template v-if="personalizacao.opcao_gabarito == 'com-gabarito'">
					<div
						class="btn-group dropup"
						v-if="produto.gabarito_illu || produto.gabarito_ps || produto.gabarito_corel"
						style="width: 100%;"
					>
						<button
							class="btn btn-secondary btn-sm dropdown-toggle sg-gabarito mx-auto"
							type="button"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
						>Baixar Gabarito</button>
						<div class="dropdown-menu" style="margin-left: -15px;">
							<template v-if="produto.gabarito_illu">
								<a
									:href="'/storage/produtos/instantaneo/arquivos/ai/' + produto.gabarito_illu"
									class="dropdown-item"
									download
									v-if="produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-illustrator.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Illustrator
								</a>
								<a
									:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_illu"
									class="dropdown-item"
									download
									v-if="!produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-illustrator.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Illustrator
								</a>
							</template>
							<template v-if="produto.gabarito_ps">
								<a
									:href="'/storage/produtos/instantaneo/arquivos/psd/' + produto.gabarito_ps"
									class="dropdown-item"
									download
									v-if="produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-photoshop.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Photoshop
								</a>
								<a
									:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_ps"
									class="dropdown-item"
									download
									v-if="!produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-photoshop.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Photoshop
								</a>
							</template>
							<template v-if="produto.gabarito_corel">
								<a
									:href="'/storage/produtos/instantaneo/arquivos/cdr/' + produto.gabarito_corel"
									class="dropdown-item"
									download
									v-if="produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-corel.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Corel Draw
								</a>
								<a
									:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_corel"
									class="dropdown-item"
									download
									v-if="!produto.atualcard"
								>
									<img
										src="/img/gabarito/gabarito-corel.jpg"
										alt="Illustrator"
										style="width: 16px; height: 16px;"
									/>
									Corel Draw
								</a>
							</template>
						</div>
					</div>
				</template>
				<template v-if="personalizacao.texto_botao_comprar != null">
					<a :href="produto.url" class="btn sg-botao">{{personalizacao.texto_botao_comprar}}</a>
				</template>
				<template v-else>
					<a :href="produto.url" class="btn sg-botao">Comprar</a>
				</template>
			</div>
		</template>

		<!--Botão do card aparece ao passar o mouse-->

		<template v-else-if="personalizacao.tipo_botao_card == 'passar_mouse'">
			<div class="card-produto-footer-shadow"></div>
			<div class="card-produto-footer" v-if="produto.preco_logado">
				<a
					href="#login"
					data-toggle="modal"
					data-target="#modalLogin"
					class="btn sg-botao botao-card-produto-footer"
				>
					<i class="fas fa-sign-in-alt"></i> Logar
				</a>
			</div>
			<div class="card-produto-footer" v-else>
				<template v-if="personalizacao.opcao_gabarito == 'com-gabarito'">
					<!--Com gabarito card completo-->
					<template v-if="personalizacao.opcao_tipo_card == 'completo'">
						<div
							class="btn-group dropup"
							v-if="produto.gabarito_illu || produto.gabarito_ps || produto.gabarito_corel"
							style="position: absolute; bottom: 70px; width: 100%"
						>
							<button
								class="btn btn-secondary btn-sm dropdown-toggle sg-gabarito mx-auto"
								type="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>Baixar Gabarito</button>
							<div class="dropdown-menu" style="margin-left: -15px;">
								<template v-if="produto.gabarito_illu">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/ai/' + produto.gabarito_illu"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-illustrator.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Illustrator
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_illu"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-illustrator.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Illustrator
									</a>
								</template>
								<template v-if="produto.gabarito_ps">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/psd/' + produto.gabarito_ps"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-photoshop.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Photoshop
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_ps"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-photoshop.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Photoshop
									</a>
								</template>
								<template v-if="produto.gabarito_corel">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/cdr/' + produto.gabarito_corel"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-corel.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Corel Draw
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_corel"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-corel.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Corel Draw
									</a>
								</template>
							</div>
						</div>
					</template>
					<!--Com gabarito card simples-->
					<template v-else-if="personalizacao.opcao_tipo_card == 'simples'">
						<div
							class="btn-group dropup"
							v-if="produto.gabarito_illu || produto.gabarito_ps || produto.gabarito_corel"
							style="position: absolute; bottom: 65px; width: 100%"
						>
							<button
								class="btn btn-secondary btn-sm dropdown-toggle sg-gabarito mx-auto"
								type="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>Baixar Gabarito</button>
							<div class="dropdown-menu" style="margin-left: -15px;">
								<template v-if="produto.gabarito_illu">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/ai/' + produto.gabarito_illu"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-illustrator.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Illustrator
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_illu"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-illustrator.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Illustrator
									</a>
								</template>
								<template v-if="produto.gabarito_ps">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/psd/' + produto.gabarito_ps"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-photoshop.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Photoshop
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_ps"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-photoshop.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Photoshop
									</a>
								</template>
								<template v-if="produto.gabarito_corel">
									<a
										:href="'/storage/produtos/instantaneo/arquivos/cdr/' + produto.gabarito_corel"
										class="dropdown-item"
										download
										v-if="produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-corel.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Corel Draw
									</a>
									<a
										:href="'/storage/produtos/' + produto.id + '/arquivos/' + produto.gabarito_corel"
										class="dropdown-item"
										download
										v-if="!produto.atualcard"
									>
										<img
											src="/img/gabarito/gabarito-corel.jpg"
											alt="Illustrator"
											style="width: 16px; height: 16px;"
										/>
										Corel Draw
									</a>
								</template>
							</div>
						</div>
					</template>
				</template>
				<template v-if="personalizacao.texto_botao_comprar != null">
					<a
						:href="produto.url"
						class="btn sg-botao botao-card-produto-footer"
					>{{personalizacao.texto_botao_comprar}}</a>
				</template>
				<template v-else>
					<a :href="produto.url" class="btn sg-botao botao-card-produto-footer">Comprar</a>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "card-produto",
	props: {
		produto: {
			default: null,
		},
		personalizacao: {
			default: null,
		},
	},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/CardProduto.vue